// export const api_url = "http://127.0.0.1:3060"
//export const api_url = "https://api.mahsool.sd"
export const api_url = process.env.REACT_APP_API_URL